import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarIcon, UsersIcon, ClockIcon, SearchIcon } from 'lucide-react';
const packages = [{
  id: 1,
  title: 'Istanbul Explorer',
  image: 'https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1171&q=80',
  price: '$799',
  duration: '5 days',
  groupSize: '10 people',
  startDate: 'Multiple dates',
  destination: 'Turkey',
  featured: true
}, {
  id: 2,
  title: 'Dubai Luxury Experience',
  image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
  price: '$1,299',
  duration: '7 days',
  groupSize: '8 people',
  startDate: 'Multiple dates',
  destination: 'Dubai',
  featured: true
}, {
  id: 3,
  title: 'Thailand Beach Getaway',
  image: 'https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1139&q=80',
  price: '$899',
  duration: '6 days',
  groupSize: '12 people',
  startDate: 'Multiple dates',
  destination: 'Thailand',
  featured: true
}, {
  id: 4,
  title: 'Cappadocia Hot Air Balloon Tour',
  image: 'https://images.unsplash.com/photo-1570654230464-9cf63245bee7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
  price: '$1,099',
  duration: '4 days',
  groupSize: '8 people',
  startDate: 'Multiple dates',
  destination: 'Turkey'
}, {
  id: 5,
  title: 'Kuala Lumpur City Break',
  image: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
  price: '$699',
  duration: '4 days',
  groupSize: '10 people',
  startDate: 'Multiple dates',
  destination: 'Malaysia'
}, {
  id: 6,
  title: 'Phuket Island Hopping',
  image: 'https://images.unsplash.com/photo-1537956965359-7573183d1f57?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1168&q=80',
  price: '$849',
  duration: '5 days',
  groupSize: '12 people',
  startDate: 'Multiple dates',
  destination: 'Thailand'
}];
const destinations = ['All', 'Turkey', 'Dubai', 'Thailand', 'Malaysia'];
const Packages = () => {
  const [selectedDestination, setSelectedDestination] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const filteredPackages = packages.filter(pkg => {
    const matchesDestination = selectedDestination === 'All' || pkg.destination === selectedDestination;
    const matchesSearch = pkg.title.toLowerCase().includes(searchTerm.toLowerCase()) || pkg.destination.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesDestination && matchesSearch;
  });
  return <div className="bg-white" data-id="element-627">
      <div className="relative bg-red-600 text-white" data-id="element-628">
        <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{
        backgroundImage: 'url("https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1121&q=80")'
      }} data-id="element-629"></div>
        <div className="container mx-auto px-4 py-24 relative z-10" data-id="element-630">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-631">
            Our Travel Packages
          </h1>
          <p className="text-xl text-center max-w-3xl mx-auto" data-id="element-632">
            Explore our carefully crafted travel packages for unforgettable
            experiences
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 py-16" data-id="element-633">
        {/* Search and Filter */}
        <div className="mb-12 bg-gray-50 p-6 rounded-lg" data-id="element-634">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4" data-id="element-635">
            <div className="relative flex-grow max-w-md" data-id="element-636">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-637">
                <SearchIcon size={18} className="text-gray-400" data-id="element-638" />
              </div>
              <input type="text" className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-red-500 focus:border-red-500 block w-full pl-10 p-2.5" placeholder="Search packages..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-639" />
            </div>
            <div className="flex flex-wrap gap-2" data-id="element-640">
              {destinations.map(destination => <button key={destination} onClick={() => setSelectedDestination(destination)} className={`px-4 py-2 rounded-full text-sm font-medium ${selectedDestination === destination ? 'bg-red-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-641">
                  {destination}
                </button>)}
            </div>
          </div>
        </div>
        {/* Packages Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-642">
          {filteredPackages.map(pkg => <div key={pkg.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow" data-id="element-643">
              <div className="relative" data-id="element-644">
                <img src={pkg.image} alt={pkg.title} className="w-full h-56 object-cover" data-id="element-645" />
                {pkg.featured && <span className="absolute top-4 right-4 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-646">
                    Featured
                  </span>}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4" data-id="element-647">
                  <div className="text-white font-bold text-xl" data-id="element-648">
                    {pkg.title}
                  </div>
                  <div className="text-white font-semibold" data-id="element-649">
                    {pkg.price}{' '}
                    <span className="text-sm font-normal" data-id="element-650">per person</span>
                  </div>
                </div>
              </div>
              <div className="p-6" data-id="element-651">
                <div className="flex flex-col space-y-3 mb-4" data-id="element-652">
                  <div className="flex items-center text-gray-600" data-id="element-653">
                    <ClockIcon size={16} className="mr-2 text-red-600" data-id="element-654" />
                    <span data-id="element-655">{pkg.duration}</span>
                  </div>
                  <div className="flex items-center text-gray-600" data-id="element-656">
                    <UsersIcon size={16} className="mr-2 text-red-600" data-id="element-657" />
                    <span data-id="element-658">Max {pkg.groupSize}</span>
                  </div>
                  <div className="flex items-center text-gray-600" data-id="element-659">
                    <CalendarIcon size={16} className="mr-2 text-red-600" data-id="element-660" />
                    <span data-id="element-661">{pkg.startDate}</span>
                  </div>
                </div>
                <Link to={`/packages/${pkg.id}`} className="block w-full bg-red-600 hover:bg-red-700 text-white text-center py-2 rounded-md font-medium" data-id="element-662">
                  View Details
                </Link>
              </div>
            </div>)}
        </div>
        {filteredPackages.length === 0 && <div className="text-center py-16" data-id="element-663">
            <h3 className="text-2xl font-medium text-gray-700 mb-2" data-id="element-664">
              No packages found
            </h3>
            <p className="text-gray-500" data-id="element-665">
              Try adjusting your search or filter criteria
            </p>
          </div>}
      </div>
    </div>;
};
export default Packages;